import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import momentPropTypes from 'react-moment-proptypes';
import { PropType as PolygotPropType } from 'redux-polyglot';
import ChartCard from 'components/ChartCard';
import HeadcountChart from './headcountchart';
import DevicesChart from './deviceschart';

const Headcount = ({
  p, match, startDate, endDate, isPrivateZone, anonymizeThreshold,
}) => (
  <div>
    <Row>
      <Col span={24}>
        <ChartCard title={p.tt('device_count')} showMin={!anonymizeThreshold} hideWeek={isPrivateZone}>
          <HeadcountChart
            zoneId={match.params.zone_id}
            p={p}
            startDate={startDate}
            endDate={endDate}
          />
        </ChartCard>
      </Col>
    </Row>
    <Row>
      <Col span={24}>
        <ChartCard title={p.tt('navigation.devices')} hideInfo hideWeek={isPrivateZone}>
          <DevicesChart
            zoneId={match.params.zone_id}
            p={p}
            startDate={startDate}
            endDate={endDate}
          />
        </ChartCard>
      </Col>
    </Row>
  </div>
);


Headcount.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  match: PropTypes.object,
  p: PolygotPropType,
  isPrivateZone: PropTypes.bool,
  anonymizeThreshold: PropTypes.bool,
};

export default Headcount;
